// extracted by mini-css-extract-plugin
export var mobileNavContainer = "mobile-menu-module--mobile-nav-container--3c-gX";
export var hamburger = "mobile-menu-module--hamburger--3cajM";
export var scrolled = "mobile-menu-module--scrolled--1SUHu";
export var mobileNav = "mobile-menu-module--mobile-nav--3SHiR";
export var active = "mobile-menu-module--active--2j_5G";
export var closeBtn = "mobile-menu-module--close-btn--1kR8C";